import { render, staticRenderFns } from "./assetTree.vue?vue&type=template&id=012538cc&"
import script from "./assetTree.vue?vue&type=script&lang=js&"
export * from "./assetTree.vue?vue&type=script&lang=js&"
import style0 from "./assetTree.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports